import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { formatAmount } from '../../../../common/utils/common.utils';
import { findInvoiceRoute } from '../../../../layout/components/SearchInvoices';
import { IAirlineWiseSalesReportTableData } from '../types/AirlineWiseSalesReportTypes';

export const AirlineWiseSalesReportColumn = (
  paramData:
    | {
        date_range: string;
        id: number | string;
      }
    | undefined
): ColumnsType<IAirlineWiseSalesReportTableData> => {
  return [
    {
      title: 'SL',
      render: (_, data, index) => 1 + index,
    },
    {
      title: 'Sales Date',
      dataIndex: 'sales_date',
      key: 'sales_date',
      render: (_, record) => {
        return `${dayjs(record.sales_date).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'Client Name',
      render: (record) => {
        return (
          <Link to={`/reports/client_ledger?client_query=${record?.client_id}`}>
            <span>{record.client_name}</span>
          </Link>
        );
      },
      width: 150,
    },
    {
      title: 'Airline Name',
      dataIndex: 'airline_name',
      key: 'airline_name',
    },
    {
      title: 'Invoice No',
      dataIndex: 'invoice_no',
      key: 'invoice_no',

      render: (_, data) => {
        const { invoice_no, invoice_category_id, invoice_id } = data;
        return (
          <>
            <Link
              to={`../${
                findInvoiceRoute(invoice_category_id) + '/' + 'details' + '/' + invoice_id
              }`}
            >
              {invoice_no}
            </Link>
          </>
        );
      },
    },
    {
      title: 'Ticket No',
      dataIndex: 'airticket_ticket_no',
      key: 'airticket_ticket_no',

      render: (_, record) => (
        <Link
          to={`/reports/ticket_wise?${paramData?.date_range}&airticket_id=${record.airticket_id}`}
        >
          {' '}
          {record.airticket_ticket_no}
        </Link>
      ),
    },
    {
      title: 'Ticket Type',
      dataIndex: 'TKT_TYPE',
      key: 'TKT_TYPE',
    },

    {
      title: 'PNR',
      dataIndex: 'airticket_pnr',
      key: 'airticket_pnr',
    },

    {
      title: 'Route',
      dataIndex: 'airticket_routes',
      key: 'airticket_routes',
    },
    {
      title: 'Segment',
      dataIndex: 'airticket_segment',
      key: 'airticket_segment',
    },
    {
      title: 'Discount',
      dataIndex: 'airticket_discount_total',
      key: 'airticket_discount_total',
      align: 'right',
      render: (_, record) => formatAmount(record?.airticket_discount_total),
    },
    {
      title: 'Extra Fee',
      dataIndex: 'airticket_extra_fee',
      key: 'airticket_extra_fee',
      align: 'right',
      render: (_, record) => formatAmount(record?.airticket_extra_fee),
    },
    {
      title: 'Sales Price',
      dataIndex: 'airticket_client_price',
      key: 'airticket_client_price',
      align: 'right',
      render: (_, record) => formatAmount(record.airticket_client_price),
    },

    {
      title: 'Purchase Price',
      dataIndex: 'airticket_purchase_price',
      key: 'airticket_purchase_price',
      align: 'right',
      render: (_, record) => formatAmount(record.airticket_purchase_price),
    },
    {
      title: 'Total Profit',
      dataIndex: 'total_profit',
      key: 'total_profit',
      align: 'right',
      render: (_, record) => (
        <>
          {record?.total_profit >= 0 ? (
            <strong style={{ color: 'green' }}>{formatAmount(record.total_profit)}</strong>
          ) : (
            <strong style={{ color: 'red' }}>{formatAmount(record.total_profit)}</strong>
          )}
        </>
      ),
    },
  ];
};

export const AirlineWiseSalesReportColumnDusty = (): ColumnsType<any> => {
  return [
    {
      title: 'Airline Name',
      dataIndex: 'airline_name',
      key: 'airline_name',
      render: (_, record) => <strong>{record?.airline_name}</strong>,
    },
    {
      title: 'Total Extra Fee',
      dataIndex: 'total_extra_fee',
      key: 'total_extra_fee',
      align: 'right',
      render: (_, record) => formatAmount(record.total_extra_fee),
    },
    {
      title: 'Total Discount',
      dataIndex: 'total_discount',
      key: 'total_discount',
      align: 'right',
      render: (_, record) => formatAmount(record.total_discount),
    },
    {
      title: 'Total Client Price',
      dataIndex: 'total_client_price',
      key: 'total_client_price',
      align: 'right',
      render: (_, record) => formatAmount(record.total_client_price),
    },
    {
      title: 'Total Purchase Price',
      dataIndex: 'total_purchase_price',
      key: 'total_purchase_price',
      align: 'right',
      className: 'table-row-color',
      render: (_, record) => formatAmount(record.total_purchase_price),
    },

    {
      title: 'Total Profit',
      dataIndex: 'total_profit',
      key: 'total_profit',
      align: 'right',
      render: (_, record) => (
        <>
          {record?.total_profit >= 0 ? (
            <strong style={{ color: 'green' }}>{formatAmount(record.total_profit)}</strong>
          ) : (
            <strong style={{ color: 'red' }}>{formatAmount(record.total_profit)}</strong>
          )}
        </>
      ),
    },
  ];
};
